import { render, staticRenderFns } from "./HomeHeader.vue?vue&type=template&id=24f8edf3&lang=pug&"
import script from "./HomeHeader.vue?vue&type=script&lang=js&"
export * from "./HomeHeader.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f8edf3')) {
      api.createRecord('24f8edf3', component.options)
    } else {
      api.reload('24f8edf3', component.options)
    }
    module.hot.accept("./HomeHeader.vue?vue&type=template&id=24f8edf3&lang=pug&", function () {
      api.rerender('24f8edf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/home/HomeHeader.vue"
export default component.exports